  <p-card>
    <p-header class="title">Links</p-header>
    <div class="scrollable-content content">
             <ul >
           <li *ngFor="let g of linkData">
            <span *ngIf="g.url" class="manage-link"><span class="seperator"></span><a href="{{g.url}}" title="{{g.title}}" target="_blank">{{g.title}}<span class="pi pi-external-link"></span></a></span>
            </li>
        </ul>
      </div>
  </p-card>